const customFieldDefaultOverride = (fieldDefault: string | string[], defaultOverride: string | string[]) => {
	if (Array.isArray(fieldDefault) && Array.isArray(defaultOverride)) {
		return fieldDefault.filter(defaultValue => {
			return defaultOverride.includes(defaultValue);
		});
	} else if (typeof fieldDefault === 'string' && typeof defaultOverride === 'string') {
		return defaultOverride;
	}
	return fieldDefault;
};

export default customFieldDefaultOverride;
